import * as React from "react";
import { useLocation, useNavigationType } from "react-router-dom";

function ScrollToTop({ scrollWindow = false }: { scrollWindow?: boolean }) {
    const { pathname } = useLocation();
    const navType = useNavigationType();

    React.useEffect(() => {
        /** Only scroll to top when the navigation type is not "POP"
         *  see https://reactrouter.com/en/main/hooks/use-navigation-type
         */
        if (navType !== "POP") {
            if (scrollWindow) {
                window.scrollTo(0, 0);
            } else {
                document.querySelector<HTMLElement>("#main")?.scrollTo(0, 0);
            }
        }
    }, [navType, pathname, scrollWindow]);

    return null;
}
export default ScrollToTop;
